// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ew-a";
export var fulfillmentFormRail = "_ew-9";
export var headerTitleRow = "_ew-c";
export var orderDetailsWrapper = "_ew-7";
export var orderLinkTrigger = "_ew-2";
export var paymentInformationGrid = "_ew-h";
export var paymentSummaryColumn = "_ew-i";
export var shipmentContainer = "_ew-b";
export var shipmentDetailsMainPane = "_ew-8";
export var shipmentNavigationCard = "_ew-5";
export var shipmentNavigationRail = "_ew-3";
export var shipmentNavigationRailHeader = "_ew-4";
export var shipmentSummaryFact = "_ew-e";
export var shipmentSummaryGrid = "_ew-d";
export var shipmentSummaryMetadataRow = "_ew-f";
export var shipmentSummaryTags = "_ew-g";
export var shipmentWorkspace = "_ew-0";
export var shipmentWorkspaceContent = "_ew-6";
export var shipmentWorkspaceHeader = "_ew-1";